import { useEffect, useState } from 'react'

interface UseCountUpOptions {
  duration?: number
  decimals?: number
}

/**
 * Custom hook for animating number counting up from 0 to target value
 * Uses requestAnimationFrame for smooth 60fps animation
 */
export function useCountUp(
  end: number,
  options: UseCountUpOptions = {}
) {
  const { duration = 1500, decimals = 0 } = options
  const [count, setCount] = useState(0)

  useEffect(() => {
    let startTime: number
    let animationFrame: number

    const animate = (currentTime: number) => {
      if (!startTime) startTime = currentTime
      const progress = Math.min((currentTime - startTime) / duration, 1)

      // Ease out cubic for smooth deceleration
      const easeOut = 1 - Math.pow(1 - progress, 3)
      const currentCount = easeOut * end

      setCount(decimals > 0 ? Number(currentCount.toFixed(decimals)) : Math.floor(currentCount))

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate)
      }
    }

    animationFrame = requestAnimationFrame(animate)
    return () => cancelAnimationFrame(animationFrame)
  }, [end, duration, decimals])

  return count
}
